import { useEffect } from "react";
import { useSelector } from "react-redux";
import { checkServer } from "../../../App";

const TemporarilyUnavailable = (props) => {

  const url = process.env.REACT_APP_API_URL_KEY.replace(/\/api$/, "") || "";
  const { language } = useSelector(state => state.Languages);

  useEffect(() => {
    const interval = setInterval(async () => {
      const result = await checkServer(url);

      if (result.status === "ok") {
        sessionStorage.removeItem("authRefreshLoopDetected");
        props.history.push(`/${language}/dashboard`);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ marginTop: "130px" }}>
      <div className="d-flex flex-column gap-3 align-items-center text-center">
        <span style={{ fontSize: "80px" }}>⚠️</span>
        <h1 style={{ fontSize: "30px" }}> Temporarily unavailable</h1>
        <div className="d-flex">
          <p style={{ fontSize: "16px" }}>We are trying to reconnect to the server</p>
          <div className='internet-connection-loader mb-2 d-md-block d-none'></div>
        </div>
      </div>
    </div>
  );
};

export default TemporarilyUnavailable;
